export default {
  pageTitle: 'Re-Shell Service',
  metaDescription: 'TEF provides re-shelling services to replace worn heat exchanger and vessel shells, restoring equipment to full operating condition.',
  sidebar: {
    heading: 'Maintenance And Reconditioning list',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reshell: 'Re-Shell',
    retubing: 'Re-Tubing',
  },
  title: 'Re-shell',
  heading: 'Heat Exchanger Shell Replacement and Welding Services',
  paragraph1: 'We provide expert welding services for replacing heat exchanger shells, ensuring reliable and efficient performance. Whether at our fully equipped workshop or directly at your site, our skilled team handles the entire process with precision and adherence to industry standards.',
  paragraph2: 'Our flexible approach minimizes downtime while delivering high-quality results tailored to your specific needs. Trust us to restore the integrity and functionality of your heat exchanger with seamless shell replacement and professional welding services.',
  steps: {
    step1: 'Prepare Shell',
    step2: 'Annealing Shell',
    step3: 'Cutting Shell',
    step4: 'Remove Shell',
    step5: 'Shell Assembly',
    step6: 'Hydrotest',
    step7: 'NDT Shell',
  },
};
